
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import TimeService from "@/services/TimeService";

@Component
export default class TimeSelector extends Vue {
  @Prop({ default: [] })
  items!: string[];

  selectedIndex = -1;

  @Prop({ default: true })
  loading!: boolean;

  @Prop({ default: "Empty" })
  emptyMessage!: string;

  loadingTimeOutVal = false;

  loadingTimeOut = setTimeout(() => {}, 1);

  @Watch("items")
  removeSelection() {
    this.selectedIndex = -1;
  }

  @Watch("loading")
  setLoadingTimeout() {
    if (!this.loading && this.loadingTimeOutVal) {
      this.loadingTimeOut = setTimeout(this.stopLoading, 500);
    } else if (this.loading && !this.loadingTimeOutVal) {
      this.loadingTimeOutVal = true;
    }
  }

  stopLoading() {
    this.loadingTimeOutVal = false;
  }

  getTimeDisplayString(dateTime: string) {
    return TimeService.getTimeFromISOString(dateTime);
  }

  emitSelectedTime(dateTime: string) {
    this.$emit("date-time-selected", dateTime);
  }
}
